module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    attrs: {
      "id": "page__paymentmethod"
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    attrs: {
      "name": "name",
      "id": "name",
      "label": "Название способа оплаты",
      "required": true,
      "error": _vm.errors.first('name'),
      "data-vv-name": "name",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.method.name),
      callback: function($$v) {
        _vm.$set(_vm.method, "name", $$v)
      },
      expression: "method.name"
    }
  }), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "type",
      "id": "type",
      "label": "Тип способа оплаты",
      "required": true,
      "error": _vm.errors.first('type'),
      "data-vv-name": "type",
      "data-vv-as": ' ',
      "disabled": true
    },
    model: {
      value: (_vm.method.type),
      callback: function($$v) {
        _vm.$set(_vm.method, "type", $$v)
      },
      expression: "method.type"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selectd": "",
      "disabled": ""
    }
  }, [_vm._v("Не установлен")]), _vm._v(" "), _vm._l((Object.values(_vm.types)), function(type) {
    return _c('option', {
      domProps: {
        "value": type.value
      }
    }, [_vm._v(_vm._s(type.name))])
  })], 2), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "forwarding_access",
      "id": "forwarding_access",
      "label": "Экспедирование груза при наличии задолженности по плательщику",
      "required": true,
      "error": _vm.errors.first('forwarding_access'),
      "data-vv-name": "forwarding_access",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.method.forwarding_access),
      callback: function($$v) {
        _vm.$set(_vm.method, "forwarding_access", $$v)
      },
      expression: "method.forwarding_access"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selectd": "",
      "disabled": ""
    }
  }, [_vm._v("Не установлено")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Разрешено")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Запрещено")])]), _vm._v(" "), _c('z-check', {
    attrs: {
      "label": "Автивен",
      "name": "active",
      "id": "active",
      "value": 1,
      "error": _vm.errors.first('active'),
      "data-vv-name": ('active'),
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.method.active),
      callback: function($$v) {
        _vm.$set(_vm.method, "active", $$v)
      },
      expression: "method.active"
    }
  }), _vm._v(" "), _c('z-check', {
    attrs: {
      "label": "Является ли статус публичным",
      "id": "public",
      "value": 1,
      "error": _vm.errors.first('public'),
      "data-vv-name": "public",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.method.public),
      callback: function($$v) {
        _vm.$set(_vm.method, "public", $$v)
      },
      expression: "method.public"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bcdb5d3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/PaymentMethod.vue
// module id = 1157
// module chunks = 0